import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X, Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Navigation = () => {
  const { language, toggleLanguage } = useLanguage();
  const t = translations[language];
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-slate-800/80 backdrop-blur-xl border-b border-teal-500/10 shadow-lg shadow-teal-500/5'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 md:h-20">
          <div className="flex-shrink-0">
            <h1 className="text-2xl font-bold text-white">{t.brandName}</h1>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('problem')}
              className="text-slate-300 hover:text-teal-400 transition-colors duration-200 font-medium"
            >
              {t.nav.problem}
            </button>
            <button
              onClick={() => scrollToSection('solution')}
              className="text-slate-300 hover:text-teal-400 transition-colors duration-200 font-medium"
            >
              {t.nav.solution}
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="text-slate-300 hover:text-teal-400 transition-colors duration-200 font-medium"
            >
              {t.nav.testimonials}
            </button>

            <div className="flex items-center space-x-2 border-l border-slate-600 pl-4">
              <Globe size={18} className="text-slate-400" />
              <button
                onClick={() => toggleLanguage('nl')}
                className={`px-2 py-1 rounded transition-colors ${
                  language === 'nl' ? 'bg-teal-500/20 text-teal-400 font-semibold' : 'text-slate-400 hover:text-teal-400'
                }`}
              >
                NL
              </button>
              <button
                onClick={() => toggleLanguage('en')}
                className={`px-2 py-1 rounded transition-colors ${
                  language === 'en' ? 'bg-teal-500/20 text-teal-400 font-semibold' : 'text-slate-400 hover:text-teal-400'
                }`}
              >
                EN
              </button>
            </div>

            <Button
              className="bg-teal-500 hover:bg-teal-400 text-slate-900 font-bold transition-all duration-200 hover:shadow-lg hover:shadow-teal-500/20"
              onClick={() => scrollToSection('cta')}
            >
              {t.nav.getStarted}
            </Button>
          </div>

          <div className="md:hidden flex items-center space-x-3">
            <div className="flex items-center space-x-1">
              <button
                onClick={() => toggleLanguage('nl')}
                className={`px-2 py-1 text-sm rounded transition-colors ${
                  language === 'nl' ? 'bg-teal-500/20 text-teal-400 font-semibold' : 'text-slate-400'
                }`}
              >
                NL
              </button>
              <button
                onClick={() => toggleLanguage('en')}
                className={`px-2 py-1 text-sm rounded transition-colors ${
                  language === 'en' ? 'bg-teal-500/20 text-teal-400 font-semibold' : 'text-slate-400'
                }`}
              >
                EN
              </button>
            </div>
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-slate-300 hover:text-teal-400 transition-colors"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-slate-900/95 backdrop-blur-xl border-t border-slate-800">
          <div className="px-4 py-4 space-y-3">
            <button onClick={() => scrollToSection('problem')} className="block w-full text-left text-slate-300 hover:text-teal-400 transition-colors font-medium py-2">{t.nav.problem}</button>
            <button onClick={() => scrollToSection('solution')} className="block w-full text-left text-slate-300 hover:text-teal-400 transition-colors font-medium py-2">{t.nav.solution}</button>
            <button onClick={() => scrollToSection('testimonials')} className="block w-full text-left text-slate-300 hover:text-teal-400 transition-colors font-medium py-2">{t.nav.testimonials}</button>
            <Button className="w-full bg-teal-500 hover:bg-teal-400 text-slate-900 font-bold transition-colors" onClick={() => scrollToSection('cta')}>{t.nav.getStarted}</Button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
